export enum EventRegistrationStatus {
	Ingeschreven = "Ingeschreven",
	Reservelijst = "Reservelijst",
	Uitgeschreven = "Uitgeschreven",
	NietIngeschreven = "Niet ingeschreven",
}
